import { TextField } from "@socar-inc/frontend-design-system";
import type { TextFieldProps } from "@socar-inc/frontend-design-system/dist/components/TextField/type";

export const DevToolsTextField = (props: TextFieldProps) => {
  return <TextField {...props} wrapperStyle={{ background: "white" }} />;
};
